export const selectZipOverlay = state => state.map.zipOverlay

export const selectCountyOverlay = state => state.map.countyOverlay
